import { ChangeDetectionStrategy, Component, input, output, computed } from '@angular/core';

import {
  ProductOptionItem,
  StockDisplayCondition,
  SUPPORTED_LANGUAGES,
} from '@pedix-workspace/utils';

import { NgClass, AsyncPipe } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';
import { IconImageComponent } from '@pedix-workspace/angular-ui-icons';
import { AvailableStockComponent, StockInfoPipe } from '@pedix-workspace/pedixapp-stock';
import { PropInSelectedLanguagePipe } from '@pedix-workspace/pedixapp-shared-pipes';
import { CounterComponent } from '../../counter/counter.component';
import { ProductDetailItemPriceComponent } from '../../product-detail-item-price/product-detail-item-price.component';

type ProductOptionItemSelector = Pick<
  ProductOptionItem,
  'id' | 'name' | 'description' | 'price' | 'priceDiscount' | 'sku' | 'image'
>;

@Component({
    selector: 'pxw-product-option-item-checkbox',
    templateUrl: './product-option-item-checkbox.component.html',
    styleUrls: ['./product-option-item-checkbox.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        TranslocoDirective,
        NgClass,
        CounterComponent,
        AsyncPipe,
        IconImageComponent,
        AvailableStockComponent,
        StockInfoPipe,
        PropInSelectedLanguagePipe,
        ProductDetailItemPriceComponent,
    ]
})
export class ProductOptionItemCheckboxComponent {
  readonly optionId = input.required<string>();
  readonly optionMin = input.required<number>();
  readonly item = input.required<ProductOptionItemSelector>();
  readonly cartItemId = input.required<string | undefined>();
  readonly displaySku = input.required<boolean>();
  readonly selectedLanguage = input.required<SUPPORTED_LANGUAGES | undefined>();
  readonly count = input.required<number>();
  readonly disableIncrement = input.required<boolean>();
  readonly displayItemQuantities = input.required<boolean>();
  readonly maxCount = input.required<number>();
  readonly displayProductPriceWithoutTaxes = input.required<boolean>();
  readonly stockDisplayCondition = input.required<StockDisplayCondition>();
  readonly stockDisplayConditionValue = input.required<number>();

  readonly countChange = output<number>();
  readonly itemNameClick = output<Event>();
  readonly itemImageClick = output<void>();

  readonly isChecked = computed(() => this.count() > 0);

  onItemNameClick($event: Event) {
    $event.preventDefault();
    $event.stopImmediatePropagation();

    this.itemNameClick.emit($event);
  }

  onItemImageClick($event: Event) {
    $event.preventDefault();
    $event.stopImmediatePropagation();

    this.itemImageClick.emit();
  }

  onCountChange(count: number) {
    this.countChange.emit(count);
  }
}
